import { actions } from "@app/utils";
import { createApiClient } from "@app/utils/apiClient";

export const videoTemplatesClient = createApiClient(
  actions["exd-storyteller-ai/templates"],
);

export const getVideoTemplates = async (filters = {}, options = {}) => {
  const response = await videoTemplatesClient.get("/", filters, options);

  if (!response.ok) {
    throw new Error("Failed to fetch video templates", { cause: response });
  }

  return response.data?.templates ?? [];
};

export const getVideoTemplate = async (id, options = {}) => {
  if (!id) {
    throw new Error("Template ID is required to fetch video template");
  }

  const response = await videoTemplatesClient.get(`/${id}`, {}, options);

  if (!response.ok) {
    throw new Error("Failed to fetch video template", { cause: response });
  }

  return response.data?.template;
};
